export const SERVER_CONTEXT_HEAD = 'SERVER_CONTEXT_HEAD';
export const SERVER_CONTEXT_STATUSCODE = 'SERVER_CONTEXT_STATUSCODE';
export const SERVER_CONTEXT_REDIRECTURL = 'SERVER_CONTEXT_REDIRECTURL';
export const SERVER_CONTEXT_REDIRECT_REASON = 'SERVER_CONTEXT_REDIRECT_REASON';

export default class ServerContextUtils {
  static #context = null;

  static setContext(context) {
    ServerContextUtils.#context = context;
  }

  static putItem(key, value) {
    if (ServerContextUtils.#context) {
      ServerContextUtils.#context[key] = value;
    }
  }

  static getItem(key) {
    if (ServerContextUtils.#context) {
      return ServerContextUtils.#context[key];
    }
  }

  static setStatusCode(status, redirecturl) {
    if (ServerContextUtils.#context) {
      ServerContextUtils.#context[SERVER_CONTEXT_STATUSCODE] = status;
      if (redirecturl) {
        ServerContextUtils.#context[SERVER_CONTEXT_REDIRECTURL] = redirecturl;
      }
      logger.info({ msg: 'Status Code set from vue', status, redirecturl });
    }
  }
}